import axiosPost from '../axiosPost';

export const endUserListGet = async (arg) => {
    const { params } = arg

    const body = {
        "service": "EndUserListGet",
        "params": params ? params : {}
    }

    try {
        const result = await axiosPost('Y', body, arg);
        console.log(result.data, body)
        return result.data.result
    } catch (err) {
        console.log(err)
    }

}